<template>
	<div>
		<p class="pb-3">
			{{label}}
		</p>	
		
	  	<ul>
	  		<li class="mb-2" v-for="(option, index) in getOptions" :key="index">
	  	     	<vs-checkbox :disabled="disabled"  v-model="answerSend" :vs-value="option">
	  	     		<p class="truncated-multi">
	  	     			{{option}}
	  	     		</p>
	  	     	</vs-checkbox>
	  	   </li>
	  	</ul>	  	
	</div>
</template>

<script type="text/javascript">
	import { mapState, mapMutations } from 'vuex';
	export default {
		props: {
			label: {
				type: String,
				required: false,
				default: 'Descripción'
			},
			answer: {
				type: [String, Array],
				required: false,
				default: ''
			},
			disabled: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				value: '',
				options: [],
			}
		},			
		computed: {
			...mapState('resource', ['indexQuestion', 'questionsByPage', 'activePopup', 'optionsDependencies']),
			answerSend: {
				get() {		
					if(typeof(this.answer) === 'string') return [];
					return this.answer ;
				},
				set(value) {					
					const data = [...value]
					this.$emit('input', data);
				}
			},			
			getOptions() {
				return this.optionsDependencies;
			}
		}
		
	}
</script>

<style type="text/css">
	.truncated-multi {
		width: 300px;
		white-space: nowrap;
	  	overflow: hidden;
	  	text-overflow: ellipsis;
	}
	@media only screen and (max-width: 768px) {
		.truncated-multi {
			width: 200px;			
		}
	}
</style>